import { render, staticRenderFns } from "./CropperImage2.vue?vue&type=template&id=1865007b&"
import script from "./CropperImage2.vue?vue&type=script&lang=js&"
export * from "./CropperImage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports